import { Link } from 'react-router-dom';
import { brandStats } from '@/mocks/homeData';

export default function BrandSection() {
  return (
    <section className="relative bg-gradient-to-b from-primary-800 to-primary-900 py-20 md:py-28">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="inline-block px-4 py-1.5 rounded-full bg-secondary-500/30 text-secondary-200 text-xs mb-6">
            <span className="whitespace-nowrap">✦ 关于我们</span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            <div>
              <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight">
                吃瓜黑料网
                <br />
                让每一个大瓜
                <br />
                都有迹可循
              </h2>
              <div className="mt-8 space-y-4">
                <p className="text-base md:text-lg text-background-50/80 leading-relaxed">
                  作为国内领先的娱乐爆料资讯平台，吃瓜黑料网致力于为全网吃瓜群众提供最新、最全、最真实的网红黑料与明星塌房资讯。
                </p>
                <p className="text-sm md:text-base text-background-50/60 leading-relaxed">
                  我们拥有一支专业的爆料追踪团队，7×24小时不间断监测网络热点，确保每一条爆料都经过严格核实，让用户在第一时间获取最真实的黑料信息。
                </p>
                <p className="text-sm text-background-50/50 leading-relaxed">
                  平台自上线以来，已累计发布超过12万条爆料资讯，日均活跃用户突破38万人次，月浏览量超过2.8亿，成为吃瓜群众最信赖的爆料平台。
                </p>
              </div>
            </div>

            <div className="flex flex-col justify-between">
              <div className="rounded-2xl overflow-hidden mb-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20newsroom%20workspace%20with%20warm%20dark%20and%20golden%20tones%2C%20multiple%20screens%20displaying%20news%20feeds%2C%20sophisticated%20professional%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20background%2C%20modern%20minimalist&width=600&height=400&seq=brand-section-img&orientation=landscape"
                  alt="吃瓜黑料网 - 专业爆料追踪团队"
                  title="吃瓜黑料网品牌展示"
                  className="w-full h-auto object-cover object-top"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 rounded-2xl bg-primary-700/50">
                  <div className="text-3xl md:text-4xl font-heading font-black text-background-50">
                    {brandStats.totalArticles}
                  </div>
                  <p className="mt-1 text-xs text-background-50/60">累计爆料</p>
                </div>
                <div className="text-center p-4 rounded-2xl bg-primary-700/50">
                  <div className="text-3xl md:text-4xl font-heading font-black text-background-50">
                    {brandStats.dailyActive}
                  </div>
                  <p className="mt-1 text-xs text-background-50/60">日均活跃用户</p>
                </div>
                <div className="text-center p-4 rounded-2xl bg-primary-700/50">
                  <div className="text-3xl md:text-4xl font-heading font-black text-background-50">
                    {brandStats.monthlyViews}
                  </div>
                  <p className="mt-1 text-xs text-background-50/60">月浏览量</p>
                </div>
                <div className="text-center p-4 rounded-2xl bg-primary-700/50">
                  <div className="text-3xl md:text-4xl font-heading font-black text-background-50">
                    {brandStats.whistleblowers}
                  </div>
                  <p className="mt-1 text-xs text-background-50/60">爆料人</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}